<!-- Dettagli testata prenotazione -->
<div class="info">
  <div class="ui-g-12 gift-info-section">
    <span class="label gift-info-title">{{ 'reservations.reservation' | translate }}</span>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'reservations.reservationNumber' | translate }}: </label>
        {{ record['id'] }}
      </span>
    </p>
    <p *ngIf="record['catalog_description']" >
      <span>
        <label style="font-weight: bold;">{{ 'catalog.catalog' | translate }}: </label>
        {{ record['catalog_description'] }}
      </span>
    </p>
    <p *ngIf="record['catalog_desc']">
      <span>
        <label style="font-weight: bold;">{{ 'catalog.catalog' | translate }}: </label>
        {{ record['catalog_desc'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'card.card_no' | translate }}: </label>
        {{ record['card_no'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'common.customer' | translate }}: </label>
        {{ balanceData.customer == undefined ? record['cust_name']+' '+record['cust_surname'] : balanceData.customer}}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'userForm.email' | translate }}: </label>
        {{ balanceData.email == undefined ? record['email'] : balanceData.email}}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'loyalty.telephone' | translate }}: </label>
        {{ balanceData.telephone == undefined ? record['telephone'] : balanceData.telephone}}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'customerList.fiscalVat' | translate }}: </label>
        {{ record['vat_fiscal_code']}}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'common.store_title' | translate }}: </label>
        {{  record['store'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'reservations.reservationDate' | translate }}: </label>
        <span *ngIf="!calendarTranslateService.checkDateFormat(record['dt_reservation'])">{{ record['dt_reservation'] | date: calendarTranslateService.pcalendarTranslate.dateFormatFilter}}</span>
        <span *ngIf="calendarTranslateService.checkDateFormat(record['dt_reservation'])">{{ record['dt_reservation'] }}</span>
      </span>
    </p>
  </div>
  <!-- Dettagli premio -->
  <div class="ui-g-12 gift-info-section">
    <span class="label gift-info-title">{{ 'reservations.gift' | translate }}</span>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'reservations.giftCode' | translate }}: </label>
        {{ record['gift_code'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'reservations.giftDescription' | translate }}: </label>
        {{ record['gift_description']}}
      </span>
    </p>
    <!-- Tipo di Consegna - Punto Vendita-->
    <p>
      <span *ngIf="
        record['delivery_type'] == 'Punto vendita' ||
        (record['delivery_type'] == 'Punto vendita o indirizzo di consegna' &&
        record['flg_pickup_store'] != 'S')">
        <label style="font-weight: bold;">{{ 'reservations.deliveryStore' | translate }}: </label>
        <span>{{ record['store_pickup']}}</span>
      </span>
    </p>
    <!-- Tipo di Consegna - Indirizzo di Consegna-->
    <p>
      <span *ngIf="
      record['delivery_type']== 'Indirizzo di consegna' ||
      (record['delivery_type'] == 'Punto vendita o indirizzo di consegna' &&
      record['flg_pickup_store'] == 'S')">
        <label style="font-weight: bold;">{{ 'reservations.deliveryAddress' | translate }}: </label>
        <span>{{ record['delivery_address']}}</span>
      </span>
    </p>
    <p>
      <span *ngIf="
      record['delivery_type']== 'Indirizzo di consegna' ||
      (record['delivery_type'] == 'Punto vendita o indirizzo di consegna' &&
      record['flg_pickup_store'] == 'S')">
        <label style="font-weight: bold;">{{ 'reservations.deliveryContact' | translate }}: </label>
        <span>{{ record['customerDescription']}}</span>
      </span>
    </p>
    <p>
      <span *ngIf="
      record['delivery_type']== 'Indirizzo di consegna' ||
      (record['delivery_type'] == 'Punto vendita o indirizzo di consegna' &&
      record['flg_pickup_store'] == 'S')">
        <label style="font-weight: bold;">{{ 'reservations.deliveryTel' | translate }}: </label>
        <span>{{ record['telephone']}}</span>
      </span>
    </p>
     <!-- Tipo di Consegna - Email/Sns-->
     <p>
      <span *ngIf="record['delivery_type']== 'Email/Sms'">
        <label style="font-weight: bold;">{{ 'reservations.mailToSend' | translate }}: </label>
        <span>{{ record['email']}}</span>
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'catalog.giftType' | translate }}: </label>
        {{ record['gift_type'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'catalog.deliveryType' | translate }}: </label>
        {{ record['delivery_type'] }}
      </span>
    </p>
    <p>
      <span>
        <label style="font-weight: bold;">{{ 'common.status' | translate }}: </label>
        {{ record['status'] }}
      </span>
    </p>
    <p *ngIf="record['rdm_points']" >
      <span>
        <label style="font-weight: bold;">{{ 'reservations.points' | translate }}: </label>
        {{ record['rdm_points'] }}
    </span>
    </p>
    <p *ngIf="record['points']" >
      <span>
        <label style="font-weight: bold;">{{ 'reservations.points' | translate }}: </label>
        {{ record['points'] }}
    </span>
    </p>
    <p *ngIf="record['rdm_value']">
      <span>
        <label style="font-weight: bold;">{{ 'catalog.contribution' | translate }}: </label>
        {{ record['rdm_value'].toFixed(2) + '€' }}
    </span>
    </p>
    <p *ngIf="record['value']">
      <span>
        <label style="font-weight: bold;">{{ 'catalog.contribution' | translate }}: </label>
        {{ record['value'].toFixed(2) + '€' }}
    </span>
    </p>
  </div>
  <p *ngIf="record['pay_code']">
    <span>
      <label style="font-weight: bold;">{{ 'reservations.payCode' | translate }}: </label>
      {{ record['pay_code'] }}
  </span>
  </p>
  <p *ngIf="record['auth_pay_code']">
    <span>
      <label style="font-weight: bold;">{{ 'reservations.authPayCode' | translate }}: </label>
      {{ record['auth_pay_code'] }}
  </span>
  </p>
</div>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-reservation-details/loyalty-reservation-details.component.html